import { Entypo } from "@expo/vector-icons";
import { Text } from "@ui-kitten/components";
import Button from "components/Button";
import { MAX_ACCOUNT_PLAN_PACKAGE_COUNT } from "constants/";
import { useAppSelector } from "hooks/useAppSelector";
import React from "react";
import { View } from "react-native";
import { getTotalPlanPackageCount } from "../registerUtils";

interface QuantitySelectorProps {
  quantity: number;
  setQuantity: (newQuantity: number) => void;
  maxPerMember?: number;
  showRemove?: boolean;
}
const QuantitySelector: React.FC<QuantitySelectorProps> = ({
  quantity,
  setQuantity,
  maxPerMember,
}) => {
  const { primaryUser, secondaryUsers } = useAppSelector(
    (state) => state.buyFlow,
  );
  const totalPlanPackageCount = getTotalPlanPackageCount(
    primaryUser,
    secondaryUsers,
  );

  const canIncrement =
    totalPlanPackageCount <= MAX_ACCOUNT_PLAN_PACKAGE_COUNT &&
    (!maxPerMember || maxPerMember < 0 || quantity < maxPerMember);

  return (
    <View className=" flex-row justify-between items-center">
      <View className="flex-row items-center">
        <Text>Quantity: </Text>
        <View className="flex-row items-center">
          <Button
            appearance="ghost"
            onPress={() => quantity > 1 && setQuantity(quantity - 1)}
          >
            {() => <Entypo name="minus" size={20} color="black" />}
          </Button>
          <View className="py-2 px-4 border">
            <Text style={{ fontSize: 20 }}>{quantity}</Text>
          </View>
          {canIncrement && (
            <Button
              appearance="ghost"
              onPress={() => setQuantity(quantity + 1)}
            >
              {() => <Entypo name="plus" size={20} color="black" />}
            </Button>
          )}
        </View>
      </View>
    </View>
  );
};

export default QuantitySelector;
